import { render, staticRenderFns } from "./PurchaseReturnCreate.vue?vue&type=template&id=80e04c0c&scoped=true"
import script from "./PurchaseReturnCreate.vue?vue&type=script&lang=js"
export * from "./PurchaseReturnCreate.vue?vue&type=script&lang=js"
import style0 from "./PurchaseReturnCreate.vue?vue&type=style&index=0&id=80e04c0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e04c0c",
  null
  
)

export default component.exports